import axios, { Method } from '@/apps/open/utils/axios'

/**
 * 获取管理员列表
 */
export async function getAdminList (params: any) {
  return axios({ url: '/api/my/user/dev_roles', method: Method.Get, params })
}

/**
 * 删除管理员
 * @param userid
 */
export async function removeAdmin (userid: number, developer_id: number | string) {
  return axios({ url: '/api/my/user/dev_role', method: Method.Delete, data: { ids: userid, developer_id } })
}

/**
 * 添加管理员
 * @param userids
 */
export async function addAdmin (userids: number[], developer_id: number | string) {
  return axios({ url: `/api/my/user/dev_role`, method: Method.Post, data: { ids: userids.join(','), dev_role: 'admin', developer_id } })
}

/**
 * 超管转让
 * @param userid
 * @param open_ssid
 */
export async function transferSuperAdmin (userid: number, developer_id: string | number, open_ssid?: string) {
  return axios({ url: `/api/my/user/assign_admin`, method: Method.Post, data: { open_ssid, assign_id: userid, developer_id } })
}
